import * as SiteStories from '../Site.stories';
import SiteInfo from './SiteInfo';

export default {
  title: 'Components/Site/SiteDetailsPage/SiteInfo',
  component: SiteInfo,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

export const Default = {
  args: {
    site: SiteStories.Default.args.siteData,
    values: {},
    modelFormItems: [],
  },
};

export const SiteInfoWithCustomFields = {
  args: {
    site: SiteStories.Default.args.siteData,
    values: {
      7: '2024',
      8: 'divider',
      9: '07/30/24',
      10: 'hello world',
    },
    modelFormItems: [
      {
        key: 6,
        type: 'header',
        label: 'workers',
        subtype: 'h3',
        position: 1,
        value: null,
      },
      {
        key: 7,
        type: 'number',
        label: 'what number',
        position: 2,
        value: null,
      },
      {
        key: 8,
        type: 'text',
        label: 'divider',
        subtype: 'text',
        position: 3,
        value: null,
        required: false,
      },
      {
        key: 9,
        type: 'date',
        label: 'creation date',
        position: 4,
        value: null,
      },
      {
        key: 10,
        type: 'textarea',
        label: 'message',
        position: 5,
        value: null,
        required: false,
      },
    ],
  },
};
